import React from 'react';

import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import TreeTableElement from './TreeTableElement';

class TreeTable extends React.Component {
	constructor(props) {
		super(props);
		this.renderHeader = this.renderHeader.bind(this);
		this.renderBody = this.renderBody.bind(this);
	}
	renderHeader() {
		return (
			<TableHead>
				<TableRow>
					{this.props.columns.map((columnName) =>
						<TableCell>{columnName}</TableCell>
					)}
				</TableRow>
			</TableHead>
		);
	}
	renderBody() {
		return (
			<TableBody>
				{this.props.documents.map(doc =>
					<TreeTableElement element={doc} depth={0}/>
				)}
			</TableBody>
		);
	}
	render() {
		return (
			<TableContainer>
				<Table size="small">
					{this.renderHeader()}
					{this.renderBody()}
				</Table>
			</TableContainer>
		);
	}
}

export default TreeTable;